import { render } from "./SelectionProcessCard.vue?vue&type=template&id=316a902e"
import script from "./SelectionProcessCard.vue?vue&type=script&lang=js"
export * from "./SelectionProcessCard.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__